import { RouteDefinition } from '../shared/navigation/route-definition';
import { RoutePaths } from '../shared/navigation/route-paths';
import { AlwaysShowRouteResolver } from '../shared/navigation/always-show-route-resolver';

export class TasksRouteDefinition {
  public static getRoutes(): RouteDefinition {
    return {
      path: RoutePaths.TASKS,
      resolver: AlwaysShowRouteResolver,
      title: 'Tasks',
      icon: 'icon-tasks.svg',
      position: 20
    };
  }
}
